/// <reference types="vite/client" />
import * as Sentry from '@sentry/react'

/**
 * B2 v6 Phase 1.3 — 前端 Sentry 接入入口.
 *
 * - DSN 通过 vite env 注入 (VITE_SENTRY_DSN_FRONTEND), 空则关闭
 * - tracesSampleRate=0 关 Performance 防 quota 烧穿
 * - ignoreErrors 屏蔽业务 4xx (员工日常会触发)
 * - dsn 不是机密, 但仍走 env, 不写死
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN_FRONTEND
  if (!dsn) {
    // 开发环境或未配置 — 静默跳过
    return
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENV || 'production',
    release: import.meta.env.VITE_APP_VERSION || '0.2.0',
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    ignoreErrors: [
      // 业务正常 4xx (我们的 ApiError 是 throw 的, 但 401/403/404 不上报)
      /^Unauthorized/i,
      /^Forbidden/i,
      /^Not Found/i,
      /登录已过期/,
      /没有权限/,
      /记录不存在/,
      // 浏览器扩展 / 第三方脚本噪声
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
    ],
    beforeSend(event, hint) {
      const err: any = hint?.originalException
      // 我们的 ApiError 携带 status; 401/403/404/422 跳过
      if (err && typeof err.status === 'number') {
        if (err.status === 401 || err.status === 403 || err.status === 404 || err.status === 422) {
          return null
        }
      }
      return event
    },
  })
}

export const ErrorBoundary = Sentry.ErrorBoundary
